import { useState } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import ConfirmationModal from "../../../../parts/modals/ConfirmationModal";
import { optionFields } from "../data/getting-started";

const publishOption = ({ workflow, option, optionObj, t }) => {
  const hasItem = optionObj[optionFields[option]];
  if (!hasItem) {
    return alert(t("customWorkflows.optionEmptyBeforePublish"));
  }
  submit(`/actions/getting-started/publish/${workflow}/${option}`, {
    method: "GET",
  });
};

const unpublishOption = ({ workflow, option }) => {
  submit(`/actions/getting-started/unpublish/${workflow}/${option}`, {
    method: "GET",
  });
};

export const GettingStartedOption = ({ option, workflow, optionObj = {} }) => {
  const { t } = useTranslation("coaching-portal");
  const { status } = optionObj;
  const published = status === "published";
  const [openedConfirmationModal, setOpenedConfirmationModal] = useState(false);

  const handleChange = () => {
    published
      ? unpublishOption({ workflow, option })
      : publishOption({ workflow, option, optionObj, t });
    setTimeout(() => {
      setOpenedConfirmationModal(false);
    }, 250);
  };
  return (
    <div className="option">
      <p className="p4">{t(`customWorkflows.optionName.${option}`)}</p>

      <div>
        <input
          type="checkbox"
          id={`switch-${option}`}
          name={`switch-${option}`}
          role="switch"
          onChange={() => {
            setOpenedConfirmationModal((prev) => !prev);
          }}
          checked={published}
        />
        <ConfirmationModal
          title={published ? t("customWorkflows.unpublish") : t("customWorkflows.publish")}
          contentText={
            published
              ? t("customWorkflows.confirmUnpublishOption")
              : t("customWorkflows.confirmPublishOption")
          }
          cancelButtonText={t("customWorkflows.cancel")}
          cancelButtonAction={() => {
            setOpenedConfirmationModal((prev) => !prev);
          }}
          confirmButtonText={published ? t("customWorkflows.unpublish") : t("customWorkflows.publish")}
          confirmButtonAction={() => handleChange()}
          isOpen={openedConfirmationModal}
          confirmSuccess={!published}
        />
      </div>
    </div>
  );
};
